import { SCORECARD_TAGS } from "../../common.js";
import { xCardScorecardApi } from "../../api.js";
import EnvironmentService from "@ane/core/lib/services/EnvironmentService";
const xCardPluginHooks = xCardScorecardApi.injectEndpoints({
  endpoints: (builder) => ({
    getAlerts: builder.query({
      query: ({ StepId, workspaceId }) => {
        return {
          url: EnvironmentService.callXCardApiCommonInfra() ? `/workspaces/${workspaceId}/plugins/defaultSummary/alerts` : `/plugins/defaultSummary/alerts`,
          body: void 0,
          method: "GET",
          params: {
            StepId
          }
        };
      },
      providesTags: (result, error, { StepId }) => [{ type: SCORECARD_TAGS.XCARD_ALERTS, StepId }]
    }),
    getAAStatus: builder.query({
      query: ({ StepId, workspaceId }) => {
        return {
          url: EnvironmentService.callXCardApiCommonInfra() ? `/workspaces/${workspaceId}/plugins/defaultSummary/aaStatus` : `/plugins/defaultSummary/aaStatus`,
          body: void 0,
          method: "GET",
          params: {
            StepId
          }
        };
      },
      providesTags: (result, error, { StepId }) => [{ type: SCORECARD_TAGS.XCARD_AASTATUS, StepId }]
    })
  })
});
const { usePrefetch: usexCardPluginsApiPrefetch, useGetAlertsQuery, useGetAAStatusQuery } = xCardPluginHooks;
export {
  useGetAAStatusQuery,
  useGetAlertsQuery,
  usexCardPluginsApiPrefetch,
  xCardPluginHooks
};
//# sourceMappingURL=default-summary.js.map
